<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <h1 class="headline">Liste des utilisateurs</h1>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 lg3 xl2 v-for="user in users" v-bind:key="user.id">
              <v-card height="100%" class="blue--text">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn dark color="blue" small flat @click="removeUserConfirm(user)">
                    <v-icon left>delete</v-icon>utilisateur
                  </v-btn>
                </v-card-actions>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ user.name}}</h3>
                    <div>{{ user.email }}</div>
                  </div>
                </v-card-title>

                <v-card-text class="pt-0 pb-0">
                  <!-- Listing des fours -->

                  <v-list v-if="user.ovens.length > 0">
                    <v-list-tile
                      class="primary--text"
                      v-for="oven  in user.ovens "
                      v-bind:key="oven.id"
                    >
                      <v-list-tile-action>
                        <v-btn icon @click="detachOvenConfirm(user, oven)">
                          <v-icon color="primary">remove_circle</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ oven.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ oven.macAddress }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title>{{ oven.serialNumber }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>

                <v-card-actions>
                  <v-btn dark block color="primary" @click="addOven(user)">
                    <v-icon left>add_circle</v-icon>four
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Dialog d'ajout de four -->
    <v-dialog v-model="addOvenDialog" persistent max-width="600px">
      <OvenAdd @close="addOvenDialog = false" @reload="loadUserList()" :user="selectedUser"></OvenAdd>
    </v-dialog>
  </v-container>
</template>


<script>
import OvenAdd from "../components/UsersAddOven";
export default {
  components: {
    OvenAdd
  },
  data: () => ({
    selectedUser: null,
    addOvenDialog: false,
    users: []
  }),
  methods: {
    // ajouter un four
    addOven(user) {
      this.selectedUser = user;
      this.addOvenDialog = true;
    },

    // chargement de la liste des utilisateurs enregistrés
    loadUserList() {
      this.api
        .get("/admin/users")
        .then(res => {
          this.users = res.data;
        })
        .catch(err => {
          console.error(err.message);
        });
    },
    // confirmation de détachement d'utilisateur
    detachOvenConfirm(user, oven) {
      // nom du four
      var ovenName = oven.name;
      if (!ovenName) {
        ovenName = oven.macAddress;
      }

      if (
        window.confirm(
          "Détacher le four " +
            ovenName +
            " de l'utilisateur " +
            user.name +
            "? "
        )
      ) {
        this.detachOven(user, oven);
      }
    },
    // détache un utilisateur
    detachOven(user, oven) {
      this.api
        .patch("/admin/users/" + user.id + "/ovens/" + oven.id + "/unrelate")
        .then(res => {
          this.loadUserList();
        })
        .catch(err => {
          console.error(err);
        });
    },
    // confirmation suppression d'un utilisateur
    removeUserConfirm(user) {
      if (window.confirm("Supprimer l'utilisateur " + user.name + " ? ")) {
        this.removeUser(user);
      }
    },
    // supprimer un utilisateur
    removeUser(user) {
      this.api
        .delete("/admin/users/" + user.id)
        .then(() => {
          this.loadUserList();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  mounted() {
    this.loadUserList();
  }
};
</script>


<style>
</style>
